    <template >
  <div v-role="roles">

  <div>
  <div class="formPosition">

  <template>

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left">
        <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
                <v-btn to="estudante-historico" class="mx-2" v-if="!progresso" fab dark color="primary" v-on="on">
                  <v-icon dark>arrow_back</v-icon>
                </v-btn>

                <v-progress-circular
                        v-if="progresso"
                        :size="50"
                        color="green"
                        indeterminate
                      ></v-progress-circular>
                    <span v-if="progresso">Carregando os dados , por favor aguarde ...</span>
                 <v-header>
                   <div style="text-align:center">
                  Preparação de Certificado - Lançamento de Notas - Estudante :<strong> {{this.$store.state.objaluno.nome}}</strong><br>
                  Turma:  <strong>{{this.$store.state.turma}}</strong> <br>

                </div>

                <div
                    v-if="$store.state.hasMessage" style="position:fixed;background-color:green;color:white;"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>

                  <div style="text-align:right">
                    <v-btn style="margin-right:15px;" v-if="showPrint" fab small color="green" @click="dialogCert=true" ><v-icon color="white;">print</v-icon></v-btn>

                    <v-btn v-if="!progresso" small color="primary" @click="FinalizarPreparacao()">Finalizar</v-btn>
                  </div>

                </v-header>
                <hr width="1007px" />

                <v-list-item-group v-model="item" color="primary">
                  <!--  1 e 2 trimestre  header -->
                  <v-row  style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="5">Disciplinas</v-col>

                    <v-col cols="12" sm="12" md="1">Nota</v-col>

                    <v-col cols="12" sm="12" md="1"></v-col>

                    <v-col cols="12" sm="12" md="1"></v-col>

                    <v-col cols="12" sm="12" md="3" v-if="!showPrint">Action</v-col>
                  </v-row>

                  <!-- end  list  header  -->

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                 <v-row  >
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="5">
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>

                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.mfd}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.iddisciplina && item.idPauta === null"
                          v-model="editedItem.mfd"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">

                      </v-col>

                      <v-col cols="12" sm="12" md="1">

                      </v-col>

                      <v-col cols="12" sm="12" md="2">

                        <v-btn
                          color="primary"
                          fab
                          x-small
                          dark
                          v-if="editedpk===item.iddisciplina"
                          @click="bt_save(editedItem)"
                        >
                          <v-icon>save_alt</v-icon>
                        </v-btn>
                        <v-btn
                          color="primary"
                          fab

                          x-small
                          dark
                          v-if="(!showPrint || item.idPauta) && ($store.state.objaluno.certificado === '0' || $store.state.objaluno.emitirCertificado === '0' ) && (item.classe !== item.anoacademico)"
                        >
                          <v-icon  @click="Eliminar(item)">delete</v-icon>
                        </v-btn>

                         <v-btn
                          color="secondary"
                          fab
                          x-small
                          dark
                          :disabled="btn_activacao1"
                          v-if="(editedpk!==item.iddisciplina && item.mfd === null)"
                          class="mr-2"
                          @click="bt_edit(item)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-col>

                    </v-row>

                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      <!--   -->
 <v-row justify="center">
    <v-dialog v-model="dialogCert" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>
        <v-icon x-large color="yellow">report_problem</v-icon><span style="font-size:18px; font-weight:bold"> Desejas continuar essa operação?</span>
        </v-col>
        </v-row>
          </v-card-title>
        <v-card-text><span style="color:red"> Esta operação resultará na cobrança deste serviço</span>, se desejares continuar clique em concordar

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn color="green darken-1" text @click="comporCertificado($store.state.objaluno, true, false)">Pré-vizualizar</v-btn>
          <v-btn color="green darken-1" text @click="certificadoPago()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialogCert=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="save_changes()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->

         <!-- ================================================ -->

            <v-row justify="center">
            <v-dialog v-model="dialog2" persistent max-width="490">
              <v-card>
                <div
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Tens certeza de que desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog2=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="FinalizarPreparacao()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->

      </v-container>
      </v-form >
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
import QRCode from 'qrcode'
const ls = require('local-storage')
export default {
  data: () => ({
    readImage: ls.get('urlReport') + `readfile/`,
    configuracoesReport: [],
    generateQR: null,
    formValid: true,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],
    dialogCert: false,
    rascunhoimge: 'https://softlineangola.com/wp-content/uploads/2020/04/rascunho-1.png',
    roles: 'prof',
    text: '',
    url: ``,
    showPrint: false,
    PreparacaoNCompleta: false,
    itemDelete: null,
    editedpk: 0,
    profediscinas: [],
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    Professor: '',
    dialog: false,
    dialog2: false,
    dialogoDisabilita: false,
    progresso_2: false,
    progresso_3: false,
    progresso: false,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: '',
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    item: 1,
    canPrint: [],
    listaPautasBloquadas: [],
    componente: [],
    componente2: [],
    componente3: [],
    componente4: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,

    editedItem: {
      descricao: '',
      idPauta: '',
      iddisciplina: '',
      mfd: 0,
      p1_notaMac: '',
      idcertificado: 0
    }
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    role () {
      return ls.get('role')
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // this.CarregActividades()
    this.pautaByTurma()
    this.carregarConfiguracoesReports()
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.iddisciplina
      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)

      if (this.formValid) {
        this.save(editedItem)
        Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)

        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      this.progresso = true
      try {
        this.progresso = true
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save () {
      var params = {
        idcertificado: (this.editedItem.idcertificado !== null) ? this.editedItem.idcertificado : 0,
        idMatricula: this.$store.state.objaluno.idMAtricula,
        nome: this.$store.state.objaluno.nome,
        iddisciplina: this.editedItem.iddisciplina,
        nota: this.editedItem.mfd,
        disciplina: this.editedItem.descricao
      }

      try {
        let msg = await axios.post('/certificadoInsertOrUpdate', params).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {

        }
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}

        if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
        } else {
          this.estudantes.push(this.editedItem)
        }
        //  this.close();
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    async pautaByTurma () {
      // carrega turma apartir de bauta  Turma
      try {
        let idmatricula = this.$store.state.objaluno.idMAtricula
        this.progresso_3 = true
        this.progresso = true
        this.listEstudantfromPauta = await axios
          .get('/preparar-certificado-listagem/' + idmatricula)
          .then(res => res.data)
        this.listEstudantfromPauta.forEach(element => {
          element.anoacademico = parseInt(element.anoacademico)
          if (element.mfd !== null) { this.PreparacaoNCompleta = false }
        })
        this.progresso_3 = false
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso_3 = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initprofdisc (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async PublicarPauta () {
      const valores =
          {
            turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
            disciplina: this.$store.state.disciplina,
            trimestre: this.$store.state.lancarNotaDe,
            bloquear: 1,
            publicar: 1,
            idControlopauta: 0
          }

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .post('/bloquearPauta', valores)
          .then(res => res.data)
        // eslint-disable-next-line no-unused-vars
        let text = 'Pauta publicada com sucesso'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado.push(valores)
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.CarregaPautas()
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async certificadoPago () {
      let item = this.$store.state.objaluno
      try {
        this.certificadosPago = await axios
          .get('/certificadoPago/' + item.pkPessoa)
          .then(res => res.data)
        // Se o certificado estiver pago então enviar-se-á os dados do aluno e a permissão de imprimir sem o rascunho
        // Se o certificado não estiver pago então checamos se a saldo disponivel nesta instituição
        if (this.certificadosPago.length > 0) { this.comporCertificado(item, false, false) } else { this.verificarPagamentoCertificado() }
      } catch (error) {
        this.text = error
      }
    },
    async  verificarPagamentoCertificado () {
      this.dialogCert = false
      try {
        this.canPrint = await axios
          .get('/verificarPagamento/' + this.$store.state.objaluno.instituicao)
          .then(res => res.data)

        if (this.canPrint.length && this.canPrint[0].quantidade_final > this.canPrint[0].consumo) {
          this.comporCertificado(this.$store.state.objaluno, false, true)
        } else {
          // Imprimir com o rascunho e não fará desconto
          this.comporCertificado(this.$store.state.objaluno, true, false)
        }
      } catch (error) {
        this.text = error
      }
    },
    async comporCertificado (dados, isRascunho, canDescontar) {
      let certificadoConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'Certificado')
      this.dialogCert = false
      this.$store.state.objaluno = dados
      try {
        this.progresso = true
        // let nomeEstudanteqrCode = (this.$store.state.objaluno.nome.toUpperCase()).split(' ').join('%20')
        // let nomeEstudante
        // Dados do certificado (Disciplinas e notas)
        // this.certificadoDoAluno.dados_pessoais = this.$store.state.objaluno
        this.componente = await axios
          .post('/certificadoComponente/' + this.$store.state.objaluno.idMAtricula)
          .then(res => res.data)
        var certificado1 = this.componente[0]
        this.componente2 = await axios
          .post('/certificadoComponente2/' + this.$store.state.objaluno.idMAtricula)
          .then(res => res.data)
        var certificado2 = this.componente2[0]
        this.componente3 = await axios
          .post('/certificadoComponente3/' + this.$store.state.objaluno.idMAtricula)
          .then(res => res.data)
        var certificado3 = this.componente3[0]
        this.componente4 = await axios
          .post('/certificadoComponente4/' + this.$store.state.objaluno.idMAtricula)
          .then(res => res.data)
        var certificado4 = this.componente4[0]
        const quant = certificado1.length + certificado2.length + certificado3.length
        this.generateQR = await QRCode.toDataURL(`Nome: ` + this.$store.state.objaluno.nome + `
            Matricula: ` + this.$store.state.objaluno.idMAtricula + `
            Instituição: ` + ls.get('instituicaodescricao') + `
            http://certificado.softlineangola.com/?q=` + this.$store.state.objaluno.idMAtricula)
        let c1 = ``
        let c2 = ``
        let c3 = ``
        let somaNotas = 0
        let pc = 0
        let mediaFimCurso = 0
        let valited = ''
        if (dados.numero_disciplinas !== (quant + certificado4.length)) { valited = 'Esperava-se ' + dados.numero_disciplinas + '  Disciplinas encontradas ' + (quant + certificado4.length) }
        let option = { 'format': 'A4',
          'border': { 'top': '20cm', // default is 0, units: mm, cm, in, px
            'right': '25cm',
            'bottom': '5cm',
            'left': '25cm'
          },
          'header': {
            'height': '5mm' },
          'footer': {
            'height': '5mm'
          } }
        // Chamando o report
        certificado1.forEach(element => {
          somaNotas += parseFloat(element.mfd)
          c1 += `
                <tr class="item">
            <td  class="linha">
                    ` + element.descricao + `
                    </td>
                    <td  class="linha">
                        ` + element.mfd + `
                    </td>
                    <td class="linha">
                     (` + this.extensao(element.mfd) + `)
                    </td >
                    <td  class="linha">
                         Valores
                    </td></tr>
                    `
        })
        certificado2.forEach(element => {
          somaNotas += parseFloat(element.mfd)
          c2 += `
                <tr class="item">
            <td  class="linha">
                    ` + element.descricao + `
                    </td>
                    <td  class="linha">
                        ` + element.mfd + `
                    </td  >
                    <td  class="linha">
                     (` + this.extensao(element.mfd) + `)
                    </td >
                    <td class="linha">
                         Valores
                    </td></tr>
                    `
        })
        certificado3.forEach(element => {
          somaNotas += parseFloat(element.mfd)
          c3 += `
                <tr class="item">
            <td  class="linha">` + element.descricao + `</td>
                    <td  class="linha">` + element.mfd + ` </td>
                    <td   class="linha">( ` + this.extensao(element.mfd) + `)</td>
                    <td class="linha">Valores</td>
                    </tr>
                    `
        })
        pc = Math.round(somaNotas / (certificado1.length + certificado2.length + certificado3.length))
        mediaFimCurso = Math.round((4 * pc + parseFloat(certificado4[0].mfd) + parseFloat(certificado4[1].mfd)) / 6)
        this.html = `
<html>
     <head>
         <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
         <style>
 
         .invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
}
         .invoice-box {
          max-width: 800px;
          margin: auto;
          padding: 30px;
          border: 1px solid #eee;
          box-shadow: 0 0 10px rgba(0, 0, 0, .15);
          font-size: 16px;
          line-height: 24px;
          font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
          color: #555;
      }
             * {
   box-sizing: border-box;
 }
 .item{
   font: 9px Andale Mono, monospace
 }
 
.column {
  float: left;
  width: 33.33%;
  padding: 5px;
}

/* Clearfix (clear floats) */
.row::after {
  content: "";
  clear: both;
  display: table;
}
 .background {
   background-image: url(` + this.readImage + `back.gif);
   height: 770px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%, 100%;
  position: relative;
 }
 .linha {
     
     border-bottom:  1px solid #828282;

   

     padding-top:2px
 }
         </style>
     </head>
     <body>
      
         <div style="border:0px solid black;" class="background" class="invoice-box">
 
             <table  style="text-align:justify; padding:35px; padding-top:0px; background-image: url('` + this.rascunho(isRascunho) + `'); background-position: center; background-repeat: no-repeat;background-size: 280px 675px;"" border="0" cellpadding="0" cellspacing="0">
               
                 <tr>
 
                     <td colspan="4">
      <div class="row">
   <div class="column">
    <p style="padding-top:10px!important">  <img src=` + this.readImage + `eltsys.png alt="Snow" style="width:50%; max-width:100px;" /> </p>
   </div>
    <div class="column">
    <center style="padding-top:15px!important">   <img src=` + this.readImage + `insignia.png  alt="Snow" style="width:25%; max-width:50px;" /> </center>
  </div>
 </div>
             <center style="font: 10px Andale Mono, monospace;"> 
   REPÚBLICA DE ANGOLA <br>
   MINISTÉRIO DA EDUCAÇÃO <br>
   ` + (certificadoConfiguracoes[0].valor).toUpperCase() + `</center><br>          
 <center><strong style="font-size: 14px;">Certificado de Habilitações</strong> </center>
       <p style="font: 9px Andale Mono, monospace"> ` + (certificadoConfiguracoes[1].valor) + `,
       certifica de acordo com o artº.25 e 27º dos Estatutos do Subsistema do Ensino Técnico Profissional, aprovado 
       pelo decreto nº 90/04 de 3 de Dezembro de 2014, que, <font color="red"><strong>` + this.$store.state.objaluno.nome.toUpperCase() + `</strong></font>, filho(a)
          de ` + this.$store.state.objaluno.nomedopai + ` e de ` + this.$store.state.objaluno.nomedamae + `, natural de ` + this.$store.state.objaluno.municipio + ` província de ` + this.$store.state.objaluno.provincia + `, nascido ` + ((this.$store.state.objaluno.datanascimento).substring(0, 10)) + `,
        portador do B.I. nº ` + this.$store.state.objaluno.bi + `, emitido aos ` + ((this.$store.state.objaluno.dataemissaobi).substring(0, 10)) + `, concluiu, em regime <u>Diurno</u>, no ano lectivo
        ` + this.$store.state.novadescricaoSelecionado + ` a ` + (certificadoConfiguracoes[2].valor) + ` ` + this.$store.state.objaluno.curso + `</strong> no ` + ls.get('instituicaodescricao') + `,
        tendo obtido as seguintes classificações, conforme consta do processo individual nº ` + this.$store.state.objaluno.idMAtricula + `.</p> 
            
                    </td>
                </tr>
      
                <tr>
                    <td style="font: 10px Times New Roman,Times,serif; padding-top:14px" rowspan="1">
                  <strong>Componente Sociocultural</strong>
                    </td>
                    <td  style="font: 10px Times New Roman,Times,serif; padding-top:14px"  colspan="4">
                      Notas &nbsp;
                    </td>
                </tr>               
                   ` + c1 + `
                <tr style="font:10px Times New Roman,Times,serif;" > 
                 <td  style="padding-top:12px">
                    
                <strong>Componente Cientifíca</strong>
                    </td>
                  </tr>
                  ` + c2 + `                
                  <tr style="font: 10px Times New Roman,Times,serif;" class="heading"> 
                     <td   style="padding-top:12px"  align="left" colspan="4" >                     
                   <strong>Componente Técnica, Tecnológica e Prática</strong>
                    </td>
                  </tr>                   
              ` + c3 + `               
                  <tr style="font: 10px Andale Mono, monospace;"class="heading"> 
                     <td  class="linha"  align="left"  >  
                  <strong> Classificação Final do Plano Curricular (PC) </strong>
                    </td>
                     <td   class="linha"  >  
                      ` + pc + `
                    </td>
                      <td   class="linha">  
                   (` + this.extensao(pc) + `)
                    </td>
                      <td  class="linha"  >
                    Valores 
                    </td>
                  </tr>

                  <tr style="font: 10px Andale Mono, monospace;" class="heading"> 
                     <td class="linha" align="left">
                <strong>Classificação da Prova de Aptidão Profissional (PAP)</strong>
                    </td>
                     <td class="linha">
                   ` + certificado4[0].mfd + `
                    </td>
                     <td class="linha">
                   (` + this.extensao(certificado4[0].mfd) + `)
                    </td>
                     <td class="linha">
                  Valores  
                    </td>
                  </tr>
                   <tr style="font: 10px Andale Mono, monospace;" class="heading"> 
                     <td class="linha" align="left">
                    <strong>Classificação do Estágio Curricular (EC)</strong> 
                    </td>
                     <td class="linha">
                  ` + (certificado4[1].mfd) + `
                    </td>
                     <td class="linha">
                     (` + this.extensao(certificado4[1].mfd) + `)
                    </td>
                     <td class="linha">
                   Valores  
                    </td>
                  </tr>

                  <tr  style="font: 10px Andale Mono, monospace;" class="heading"> 
                     <td class="linha" align="left" >
                   <strong>Classificação Final do Curso=(4XPC+PAP+EC)/6</strong> 
                    </td>
                       <td class="linha">
                    ` + mediaFimCurso + `
                    </td>
                     <td class="linha">
                     (` + this.extensao(mediaFimCurso) + `)
                    </td>
                     <td class="linha">
                Valores 
                    </td>
                  </tr>
               
            </table>
             </div>
            
           <div class="background" class="invoice-box">
        <br><br> <br>
        <table style="text-align:justify; padding:30px; padding-top:1px">
       <tr style="font: 10px Andale Mono, monospace">
           <td>Pelo que, para efeitos legais e de harmonia com a legislação em vigor, lhe mandámos passar o presente certificado, que vai por mim assinado e autenticado com selo branco em uso nesta Escola.
             </td></tr>
          
         </table>
        <center style="font: 10px Andale Mono, monospace">` + (certificadoConfiguracoes[0].valor) + `, ` + this.dia() + ` de ` + this.monthName() + `.</center><br>
       <br><center style="font: 12px Times New Roman, Times, serif">O(A) DIRECTOR(A) DA ESCOLA</center><br>
       <center>____________________________________</center><br>
       <center style="font: 12px Andale Mono, monospace">` + (certificadoConfiguracoes[3].valor) + `</center>
       <center style="font: 12px Andale Mono, monospace">` + (certificadoConfiguracoes[4].valor) + `</center><br><br>
        <table border="0" style="text-align:justify; padding:30px;">
            <tr style="font: 10px Andale Mono, monospace">
                <td><b>CONTA</b></td>
                 <td valign="center" rowspan="6" ><img style="position:relative;left:210px;" id='qrcode' src=` + this.generateQR + ` alt=""  width="90" height="90" />
               </td>
            </tr>
             <tr style="font: 10px Andale Mono, monospace">         
               <td >Emolumentos.........................................</td>
               <td ></td>
             </tr>
          <tr style="font: 10px Andale Mono, monospace">      
               <td >Buscas....................................................</td>
               <td ></td>
            </tr>
           <tr style="font: 10px Andale Mono, monospace">  
               <td>Papel......................................................</td>
               <td></td>
           </tr>
         <tr style="font: 10px Andale Mono, monospace"> 
               <td >Participação de Emolumentos................</td>
               <td></td>
         </tr>
          <tr style="font: 10px Andale Mono, monospace">    
               <td ><b>TOTAL</b>..................................................</td>
               <td ></td>
          </tr>
       </table>
               <span style="color:red;font-size:18px; font-weight:bold">` + valited + `</span>
        </div>
 
       </body>
</html>
`

        this.gerarPdfCertificado(option, canDescontar)
      } catch (error) {
        this.progresso = false
      } finally {
        this.progresso = false
      }
    },
    async gerarPdfCertificado (option, canDescontar) {
      this.progresso = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile', //  http://relatorios.softlineangola.com
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.progresso = false
        this.frameCertificado(canDescontar)
      } catch (error) {
        this.progresso = false
      }
    },
    frameCertificado (canDescontar) {
      if (canDescontar) {
        this.descontarEmulumentoPago()
        this.insertImprimirCertificado(this.$store.state.objaluno)
      }
      let link = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.progresso = false
    },
    async descontarEmulumentoPago () {
      // eslint-disable-next-line no-unused-vars
      let descontandoEmolumento
      const value = {
        pkpagamentoEmolumento: this.canPrint[0].pkpagamentoEmolumento,
        consumo: ((this.canPrint[0].consumo) + 1),
        idPessoa: ls.get('nomeUsuario')
      }
      try {
        descontandoEmolumento = await axios
          .post('/DescontarEmolumentoPago', value)
          .then(res => res.data)
      } catch (error) {
        console.log('A API DescontandoEmolumento) ' + error)
        this.text = error
      }
    },
    async insertImprimirCertificado (item) {
      const value = {
        pkPessoa: item.pkPessoa,
        matricula: item.idMatricula,
        autor: ls.get('nomeUsuario')
      }
      try {
        // eslint-disable-next-line no-unused-vars
        let insertCertificadoPago = await axios
          .post('/insertImprimirCertificado', value)
          .then(res => res.data)
      } catch (error) {
        this.text = error
      }
    },
    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    dia () {
      var day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    },
    rascunho (putRascunho) {
      return putRascunho === true ? this.rascunhoimge : ''
      // return ''
    },
    extensao (valor) {
      switch (valor) {
        case '10':
          return 'Dez'
        case '11':
          return 'Onze'
        case '12':
          return 'Doze'
        case '13':
          return 'Treze'
        case '14':
          return 'Catorze'
        case '15':
          return 'Quinze'
        case '16':
          return 'Dezasseis'
        case '17':
          return 'Dezassete'
        case '18':
          return 'Dezoito'
        case '19':
          return 'Dezanove'
        case '20':
          return 'Vinte'
        case 10:
          return 'Dez'
        case 11:
          return 'Onze'
        case 12:
          return 'Doze'
        case 13:
          return 'Treze'
        case 14:
          return 'Catorze'
        case 15:
          return 'Quinze'
        case 16:
          return 'Dezasseis'
        case 17:
          return 'Dezassete'
        case 18:
          return 'Dezoito'
        case 19:
          return 'Dezanove'
        case 20:
          return 'Vinte'

        default:
          return 'Valor inválido'
      }
    },

    convertDate (dateString) {
      var p = dateString.split('-')
      // eslint-disable-next-line standard/array-bracket-even-spacing
      return [p[2], p[1], p[0] ].join('/')
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report' })
          .then(res => res.data)
        // console.log(msg)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    },
    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              trimestre: this.$store.state.lancarNotaDe,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios

            .post('/bloquearPauta', valores)
            .then(res => res.data)
          // eslint-disable-next-line no-unused-vars
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.CarregaPautas()
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    async  FinalizarPreparacao () {
      //
      this.pautaByTurma()
      this.listEstudantfromPauta.forEach(element => {
        if (element.mfd === null) { this.PreparacaoNCompleta = true }
      })
      if (!this.PreparacaoNCompleta) {
        try {
          let msg = await axios

            .get('/ActualizaStatusCertificado/' + this.$store.state.objaluno.pkPessoa)
            .then(res => res.data)

          if (msg.length) {

          } else {
            this.$store.dispatch('textMessage', {
              msg: 'Certificado preparado com sucesso',
              classMessage: 'msgSucess',
              timeout: 4000
            })
            // this.$router.push('Listagem-preparar-certificado')
            this.showPrint = true
          }

          this.dialog2 = false
        } catch (error) {
        // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      } else {
        this.$store.dispatch('textMessage', {
          msg: 'Ainda tem notas por lançar , por favor termine o lançamento de notas',
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    MostraProfessor () {
      let valor = this.profediscinas.filter(d => d.iddisciplina === this.$store.state.disciplina)
      if (valor.length) {
        this.Professor = valor[0].nome
        this.descricao_Prof = 'disciplina atrbuida ao Professor'
      } else {
        this.Professor = 'Sem Professor Associado'
        this.descricao_Prof = ''
      }
    },

    async CarregaPautas () {
      if (!this.$store.state.bloqueado.length) {
        try {
          this.$store.state.bloqueado = await axios

            .get('/ListarPautaBloqueada')
            .then(res => res.data)
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    async  Eliminar (item) {
      this.itemDelete = item
      this.dialog = true
      //
    },
    save_changes () {
      let indexOf = this.listEstudantfromPauta.indexOf(this.itemDelete)
      this.EliminaItem(this.itemDelete, indexOf)
    },

    async EliminaItem (item, indexOf) {
      try {
        this.progresso_2 = true
        let msg = await axios

          .get('/deleteDisciplina-certificado/' + item.idcertificado)
          .then(res => res.data)
        this.progresso_2 = false

        if (msg.length) {

        } else {
          this.listEstudantfromPauta.splice(indexOf, 1)
          this.dialog = false
        }
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },

    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma === this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina === this.$store.state.disciplina && block.publicar === 1 && block.bloquear === 1 && block.trimestre === this.$store.state.lancarNotaDe)
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true)

        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.HabilitaBotoes(false)
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_description = 'Bloquear'
        this.HabilitaBotoes(false)
      }
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      try {
        this.progresso_2 = true
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
        this.progresso_2 = false
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
